/**
 * Paletas de falso color PET (CLUTs 256). RGB 0–255.
 */

function lerp(a, b, t) {
  return a + (b - a) * t
}

function sampleStops(stops, t) {
  if (t <= 0) return stops[0].rgb.slice()
  if (t >= 1) return stops[stops.length - 1].rgb.slice()
  for (let i = 1; i < stops.length; i++) {
    if (t <= stops[i].t) {
      const a = stops[i - 1]
      const b = stops[i]
      const u = (t - a.t) / Math.max(1e-6, b.t - a.t)
      return [
        Math.round(lerp(a.rgb[0], b.rgb[0], u)),
        Math.round(lerp(a.rgb[1], b.rgb[1], u)),
        Math.round(lerp(a.rgb[2], b.rgb[2], u)),
      ]
    }
  }
  return stops[stops.length - 1].rgb.slice()
}

function buildTable(stops) {
  const table = new Uint8Array(256 * 3)
  for (let i = 0; i < 256; i++) {
    const rgb = sampleStops(stops, i / 255)
    table[i * 3] = rgb[0]
    table[i * 3 + 1] = rgb[1]
    table[i * 3 + 2] = rgb[2]
  }
  return table
}

/** Hot Metal / Hot Iron (clínico PET). */
export const HOT_METAL_STOPS = [
  { t: 0, rgb: [0, 0, 0] },
  { t: 0.25, rgb: [128, 0, 0] },
  { t: 0.5, rgb: [255, 64, 0] },
  { t: 0.75, rgb: [255, 220, 0] },
  { t: 1, rgb: [255, 255, 255] },
]

/** Rainbow (NIH / 3D slicer style). */
export const RAINBOW_STOPS = [
  { t: 0, rgb: [0, 0, 0] },
  { t: 0.17, rgb: [0, 0, 180] },
  { t: 0.33, rgb: [0, 180, 180] },
  { t: 0.5, rgb: [0, 200, 0] },
  { t: 0.67, rgb: [220, 220, 0] },
  { t: 0.83, rgb: [220, 80, 0] },
  { t: 1, rgb: [255, 255, 255] },
]

/** PET Fire (negro → púrpura → rojo → amarillo). */
export const PET_FIRE_STOPS = [
  { t: 0, rgb: [0, 0, 0] },
  { t: 0.2, rgb: [80, 0, 120] },
  { t: 0.45, rgb: [200, 0, 40] },
  { t: 0.7, rgb: [255, 120, 0] },
  { t: 1, rgb: [255, 255, 180] },
]

export const PET_CLUT_IDS = ['hotMetal', 'rainbow', 'petFire']

export const PET_CLUT_LABELS = {
  hotMetal: 'Hot Metal',
  rainbow: 'Rainbow',
  petFire: 'PET Fire',
}

const TABLE_CACHE = {
  hotMetal: buildTable(HOT_METAL_STOPS),
  rainbow: buildTable(RAINBOW_STOPS),
  petFire: buildTable(PET_FIRE_STOPS),
}

export function getPetClutTable(id) {
  return TABLE_CACHE[id] || TABLE_CACHE.hotMetal
}

/**
 * Mapea valor [vmin,vmax] → RGB. Devuelve null si queda bajo umbral (transparente).
 */
export function mapValueToRgb(value, vmin, vmax, table, alphaCut = 0.04) {
  const span = vmax - vmin
  if (!(span > 0)) return null
  const t = (Number(value) - vmin) / span
  if (!(t >= alphaCut)) return null
  const idx = Math.max(0, Math.min(255, Math.round(t * 255)))
  return [table[idx * 3], table[idx * 3 + 1], table[idx * 3 + 2], t]
}
